<template>
  <a-form
    ref="formRef"
    :model="formState"
    :rules="rules"
    :label-col="{
      span: 7,
    }"
    :wrapper-col="{
      span: 13,
    }"
  >
    <a-form-item ref="name" label="流程名" name="name">
      <a-input v-model:value="formState.name" />
    </a-form-item>
    <a-form-item
      ref="processDefinitionId"
      label="流程定义"
      name="processDefinitionId"
    >
      <a-select
        v-model:value="formState.processDefinitionId"
        :options="processDefinition"
        placeholder="点击绑定流程定义"
      ></a-select>
    </a-form-item>
    <a-form-item ref="type" label="类型" name="type" class="process_type">
      <a-select
        v-model:value="formState.type"
        :options="constantToOptions(processType)"
      ></a-select>
    </a-form-item>

    <a-form-item :wrapper-col="{ span: 14, offset: 8 }">
      <a-button type="primary" @click="onSubmit">提交</a-button>
      <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
    </a-form-item>
  </a-form>
</template>
<script setup>
  import {
    reactive,
    ref,
    toRaw,
    defineProps,
    defineEmits,
    onMounted,
  } from 'vue'
  import { message } from 'ant-design-vue'
  import { createProc, updateProc, getProcDef } from '@/api/process'
  import { processType } from '@/utils/common'
  import { dataToOptions, constantToOptions } from '@/utils/format'

  //流程定义
  const processDefinition = ref([])
  async function fetch() {
    const res = await getProcDef()
    if (res.success)
      processDefinition.value = dataToOptions(res.data, {
        value: 'process_definition_id',
      })
  }
  onMounted(fetch)

  //表单填写
  const props = defineProps({ isEdit: Boolean, editData: Object, data: Array })
  const formRef = ref()

  const defaultFormState = props.isEdit
    ? {
        processId: props.editData.process_id,
        name: props.editData.name,
        type: props.editData.type + '',
        processDefinitionId:
          props.editData?.process_definition?.process_definition_id,
      }
    : {
        name: '',
        type: '',
        processDefinitionId: '',
      }
  const formState = reactive(defaultFormState)

  const rules = {
    name: [
      {
        required: true,
        message: '请输入流程名',
        trigger: 'change',
      },
      {
        min: 1,
        max: 30,
        message: '不能超过30个文字',
        trigger: 'blur',
      },
    ],
    type: [
      {
        required: true,
        message: '请选择类型',
        trigger: 'change',
      },
    ],
    processDefinitionId: [
      {
        required: true,
        message: '请选择流程定义',
        trigger: 'blur',
      },
    ],
  }

  //表单提交
  const emit = defineEmits(['submit'])
  function onSubmit() {
    formRef.value
      .validate()
      .then(() => {
        handelCreate(toRaw(formState))
      })
      .catch((error) => {
        console.log('创建流程错误：', error)
      })
  }
  async function handelCreate(data) {
    const ajaxFn = props.isEdit ? updateProc : createProc
    const messageText = props.isEdit ? '编辑' : '创建'
    const res = await ajaxFn(data)
    if (res.success) {
      message.success(messageText + '流程成功！')
      emit('submit')
    } else {
      message.warn(messageText + '流程错误：', res.message)
    }
  }

  function resetForm() {
    formRef.value.resetFields()
  }
</script>
<style type="lass" scoped>
  .process_type {
    .ant-radio-group {
      display: flex;
      flex-direction: column;
    }
  }
</style>
